import type {
  DomainEntityConfiguration,
  ConfigEntityConfiguration,
  DomainEntity,
  ConfigEntity,
} from '../../types/configuration';

export type EntityOrConfiguration =
  | DomainEntity
  | DomainEntityConfiguration
  | ConfigEntityConfiguration
  | ConfigEntity;

export type EntityWithSchema =
  | DomainEntity
  | ConfigEntityConfiguration
  | ConfigEntity;

export const hasSchema = (
  entity: EntityOrConfiguration,
): entity is EntityWithSchema =>
  'schema' in entity && entity.schema !== undefined;

export const isDomainEntity = (
  entity: EntityOrConfiguration,
): entity is DomainEntity =>
  'schema' in entity &&
  !!entity.schema &&
  'labelKey' in entity &&
  !!entity.labelKey;

export const isConfigEntity = (
  entity: EntityOrConfiguration,
): entity is ConfigEntity =>
  'schema' in entity &&
  !!entity.schema &&
  'domainEntity' in entity &&
  !!entity.domainEntity;

export const isConfigEntityConfiguration = (
  entity: EntityOrConfiguration,
): entity is ConfigEntityConfiguration =>
  'schema' in entity &&
  !!entity.schema &&
  entity.category === 'core' &&
  !('domainEntity' in entity);

export const isEntity = (
  entity: EntityOrConfiguration,
): entity is DomainEntity | ConfigEntity =>
  isDomainEntity(entity) || isConfigEntity(entity);
